<template>
    <PublicTemplate v-if="product">
        <section v-if="product.slide" class="hero-single fade_in">
            <div class="image_wrapper"><img :src="product.slide" alt="hero single"></div>
        </section>
        <section v-if="product.productIntro" class="product-intro">
            <div class="animated fadeInUp" style="animation-duration: 1s;">
                <div class="container">
                    <div v-if="product.productIntro.featured" class="product_featured">
                        <div data-rmiz-wrap="visible">
                            <img :src="product.productIntro.featured" alt="OUTSWING CASEMENT WINDOW HARDWARE SERIES"
                                width="500">
                            <button aria-label="Zoom image" data-rmiz-btn-open="true"></button>
                        </div>
                    </div>
                    <div v-if="product.productIntro.info" class="product_info">
                        <h3 v-if="product.productIntro.info.line">{{ product.productIntro.info.line }}</h3>
                        <h1 v-if="product.productIntro.info.name">{{ product.productIntro.info.name }}</h1>
                        <ul class="window-product-types" v-if="product.productIntro.info.type">
                            <h5>Loại</h5>
                            <li v-for="ty in product.productIntro.info.type" :key="ty.href"
                                v-bind:class="{ 'is_active': ty.href == link }">
                                <router-link :to="ty.href">{{ ty.name }}</router-link>
                            </li>
                        </ul>
                        <div class="section_description content" v-if="product.productIntro.info.description">
                            {{ product.productIntro.info.description }}
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section v-if="product.aboutProduct" class="about-product">
            <div class="container">
                <h3 v-if="product.aboutProduct.subtitle" class="content_subtitle">{{ product.aboutProduct.subtitle }}
                </h3>
                <h2 v-if="product.aboutProduct.title" class="content_title">{{ product.aboutProduct.title }}</h2>
                <div v-if="product.aboutProduct.content_center" class="content_center content">
                    {{ product.aboutProduct.content_center }}
                </div>
                <h3 class="content_title suitable_title" v-if="product.aboutProduct.suitable_list">Thích hợp cho</h3>
                <div class="suitable_list" v-if="product.aboutProduct.suitable_list">
                    <ul>
                        <li v-for="ii in product.aboutProduct.suitable_list" :key="ii">{{ ii }}</li>
                    </ul>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                    <p>&nbsp;</p>
                </div>
            </div>
        </section>
        <section v-if="product.specification" class="product-specification">
            <div class="animated fadeInUp" style="animation-duration: 1s;">
                <div class="container">
                    <h2 class="content_subtitle">Thông số kỹ thuật</h2>
                    <h3 class="content_title" v-if="product.specification.title">{{ product.specification.title }}</h3>
                    <div class="section_description content" v-if=product.specification.table>
                        <figure class="table" v-html="product.specification.table"></figure>
                    </div>
                    <div v-if="product.specification.systemSolution"
                        class="SiteButton__LinkWrapper-o4bfn9-0 iBTqZx link_wrapper">
                        <router-link :to="product.specification.systemSolution">Xem giải pháp hệ thống</router-link>
                    </div>
                </div>
            </div>
        </section>
        <section v-if="product.imageContent" class="product-image-content">
            <div class="container_image_content" v-for="(im, k) in product.imageContent" :key="im">
                <div v-if="k % 2 == 0" class="img_container"><img :src="im.img" alt=""></div>
                <div class="content_container">
                    <h3 class="title">{{ im.content.title }}</h3>
                    <p class="description">{{ im.content.description }}</p>
                </div>
                <div v-if="k % 2 != 0" class="img_container"><img :src="im.img" alt=""></div>
            </div>
        </section>
        <section v-if="product.hardwareParts" class="hardware-parts bg_light section_paddings"
            v-bind:class="{ 'pt-5': product.parents == 1 }">
            <div class="animated fadeInUp" style="animation-duration: 1s;">
                <div class="container" v-bind:class="{ 'pt-5': product.parents == 1 }">
                    <h3 v-if="product.hardwareParts.title" class="content_subtitle">{{ product.hardwareParts.title }}
                    </h3>
                    <h2 class="content_title">Phụ kiện phần cứng</h2>
                    <div class="react-tabs" data-tabs="true">
                        <ul class="react-tabs__tab-list" role="tablist">
                            <li class="react-tabs__tab" v-on:click="tab = 1"
                                v-bind:class="{ 'react-tabs__tab--selected': tab == 1 }" role="tab">Tay nắm</li>
                            <li class="react-tabs__tab" v-on:click="tab = 2"
                                v-bind:class="{ 'react-tabs__tab--selected': tab == 2 }" role="tab">Bộ truyền động</li>
                            <li class="react-tabs__tab" v-on:click="tab = 3"
                                v-bind:class="{ 'react-tabs__tab--selected': tab == 3 }" role="tab">Bộ khóa</li>
                            <li class="react-tabs__tab" v-on:click="tab = 4"
                                v-bind:class="{ 'react-tabs__tab--selected': tab == 4 }" role="tab">Bộ chịu tải</li>
                            <li class="react-tabs__tab" v-on:click="tab = 5"
                                v-bind:class="{ 'react-tabs__tab--selected': tab == 5 }" role="tab">Phụ kiện</li>
                        </ul>
                        <div v-for="(h, k) in product.hardwareParts.hardware" :key="h">
                            <HardwareTab v-if="tab == k + 1" :tabData="h" />
                        </div>

                    </div>
                </div>
            </div>
        </section>
        <section v-if="product.keyElements" class="window-key-elements section_paddings">
            <div class="container">
                <h4 class="content_subtitle">Yếu tố quan trọng</h4>
                <h3 class="content_title" v-if="product.keyElements.title">{{ product.keyElements.title }}</h3>
                <div class="animated fadeInUp" style="animation-duration: 1s;" v-if="product.keyElements.element">
                    <div class="element" v-for="e in product.keyElements.element" :key="e">
                        <div class="image" v-if="e.image">
                            <img :src="e.image" alt="Handle choice">
                        </div>
                        <div class="content_wrap">
                            <h3 class="content_title" v-if="e.title">{{ e.title }}</h3>
                            <div class="section_description content" v-if="e.description">{{ e.description }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="solutions-section" v-if="product.solutionsSection">
            <span class="back_to_projects"><i class="far fa-long-arrow-left"></i> Go Back</span>
            <div class="container">
                <div class="solutions_wrapper">
                    <div class="solutions_heading">
                        <h2 class="section_title" v-if="product.solutionsSection.section_title">{{
                            product.solutionsSection.section_title }}</h2>
                        <p class="section_description" v-if="product.solutionsSection.section_description">{{
                            product.solutionsSection.section_description }}</p>
                    </div>
                    <div v-if="product.solutionsSection.solutions_images_grid" class="solutions_images_grid"
                        v-html="product.solutionsSection.solutions_images_grid"></div>
                </div>
            </div>
        </section>

        <section v-if="product.handlesInHandleSeries" class="handles-in-handle-series bolkKp bg_light">
            <div class="animated fadeInUp" style="animation-duration: 1s;">
                <div class="container">
                    <h2 class="content_subtitle">{{ product.handlesInHandleSeries.substring }}</h2>
                    <h3 class="content_title">{{ product.handlesInHandleSeries.title }}</h3>
                    <ul class="projects_list">

                        <ProductHandleInHandle :link="ph" v-for="ph in product.handlesInHandleSeries.projects"
                            :key="ph" />
                    </ul>
                </div>
            </div>
        </section>
    </PublicTemplate>
</template>

<script>
import PublicTemplate from '@/templates/PublicTemplate.vue';
import HardwareTab from '@/components/HardwareTab.vue';
import ProductHandleInHandle from '@/components/ProductHandleInHandle.vue';
export default {
    data() {
        return {
            tab: 1,
            data: null
        }
    },
    async mounted() {
        window.scrollTo(0, 0);

    },
    computed: {
        product() {
            return this.$store.getters.product(this.link);
        },
        link() {
            return this.$route.path;
        }
    },
    watch: {
        link() {
            window.scrollTo(0, 0);
        }
    },
    name: 'ProductView',
    components: {
        PublicTemplate,
        HardwareTab,
        ProductHandleInHandle
    }
}
</script>


<style lang="less">
.iBTqZx {
    margin-top: 50px;
    text-align: center;
    display: grid;
    place-items: center;
}

/*!sc*/
.iBTqZx a {
    font-size: 0.5em;
    -webkit-letter-spacing: 1.4px;
    -moz-letter-spacing: 1.4px;
    -ms-letter-spacing: 1.4px;
    letter-spacing: 1.4px;
    color: #050505;
    -webkit-text-decoration: none;
    text-decoration: none;
    padding: 15px 60px;
    border: 1px solid #0b0b0b;
    border-radius: 4px;
    text-transform: capitalize;
    -webkit-transition: var(--transition);
    transition: var(--transition);
    display: inline;
    text-transform: uppercase;
}

/*!sc*/
@media (max-width:1024px) {
    .iBTqZx a {
        font-size: 0.7em;
        padding: 12px 50px;
    }
}

/*!sc*/
.iBTqZx a:hover {
    background: var(--brand_black);
    color: #fff;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
data-styled.g4[id="SiteButton__LinkWrapper-o4bfn9-0"] {
    content: "iBTqZx,"
}

/*!sc*/
.hWBHX {
    background: var(--brand_black);
    opacity: 0;
    -webkit-transition: var(--transition);
    transition: var(--transition);
    overflow: hidden;
}

/*!sc*/
.hWBHX.fade_in {
    opacity: 1;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper {
    padding-top: 40px;
    padding-bottom: 40px;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper {
        padding-top: 50px;
        padding-bottom: 15px;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    -webkit-column-gap: 90px;
    column-gap: 90px;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
        grid-template-columns: 1fr;
    }
}

/*!sc*/
@media (max-width:480px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
        text-align: center;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 {
    margin-bottom: 55px;
    color: white;
    text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 {
        margin-bottom: 30px;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 svg {
    height: 34px;
    margin-right: 15px;
    fill: white;
    padding-top: 6px;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 svg {
        height: 26px;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .content_wrap {
    margin-bottom: 35px;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .content_wrap p {
    color: #fff;
    text-align: left;
    margin-bottom: 15px;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper {
    display: block;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper {
        padding-bottom: 60px;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper {
    place-items: left;
    display: block;
    text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper {
        place-items: center;
        text-align: center;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper a {
    color: white;
    border: 1px solid white;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper a:hover {
    color: var(--brand_black);
    background-color: white;
    -webkit-transform: translateY(-3px);
    -ms-transform: translateY(-3px);
    transform: translateY(-3px);
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image {
    padding-top: 75%;
    display: block;
    -webkit-text-decoration: none;
    text-decoration: none;
    overflow: hidden;
    position: relative;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image {
        display: none;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image img {
    height: 100%;
    display: block;
    position: absolute;
    object-fit: cover;
    object-position: center;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

/*!sc*/
data-styled.g5[id="LearnHow__LearnHowWrap-bgqo87-0"] {
    content: "hWBHX,"
}

/*!sc*/
.hero-single {
    width: 100%;
    position: relative;
    overflow: hidden;
    background-color: var(--brand_black);
    opacity: 0;
    display: block;
    -webkit-transition: var(--transition);
    transition: var(--transition);
    margin-top: 90px;
}

/*!sc*/
@media (max-width:1024px) {
    .hero-single {
        margin-top: 50px;
    }
}

/*!sc*/
.hero-single.fade_in {
    opacity: 1;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.hero-single:before {
    content: ' ';
    display: block;
    background-color: black;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.3;
    z-index: 1;
}

/*!sc*/
.hero-single .glide .glide__track .glide__slide {
    height: 70vh;
    min-height: 600px;
    position: relative;
    width: 100%;
    overflow: hidden;
}

/*!sc*/
@media (max-width:1024px) {
    .hero-single .glide .glide__track .glide__slide {
        height: 600px;
        min-height: 300px;
    }
}

/*!sc*/
@media (max-width:768px) {
    .hero-single .glide .glide__track .glide__slide {
        height: 300px;
        min-height: 300px;
    }
}

/*!sc*/
.hero-single .glide .glide__track .glide__slide:before {
    content: ' ';
    display: block;
    background-color: black;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.3;
    z-index: 1;
}

/*!sc*/
.hero-single .glide .glide__track .glide__slide img {
    display: block;
    position: absolute;
    object-fit: cover;
    min-width: 100%;
}

/*!sc*/
@media (max-width:1024px) {
    .hero-single .glide .glide__track .glide__slide img {
        height: 100%;
        width: auto;
    }
}

/*!sc*/
.hero-single .video_wrapper,
.hero-single .image_wrapper {
    position: relative;
}

/*!sc*/
@media (max-width:768px) {}

/*!sc*/
.hero-single .video_wrapper:before,
.hero-single .image_wrapper:before {
    content: ' ';
    display: block;
    background-color: black;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.3;
    z-index: 1;
}

/*!sc*/
.hero-single .video_wrapper video,
.hero-single .image_wrapper video,
.hero-single .video_wrapper>img,
.hero-single .image_wrapper>img {
    display: block;
    width: 100%;
}

/*!sc*/
@media (max-width:1024px) {}

/*!sc*/
.hero-single video,
.hero-single>img {
    display: block;
    min-width: 100%;
}

/*!sc*/
.hero-single .hero_headings {
    position: absolute;
    z-index: 2;
    text-align: center;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    color: white;
}

/*!sc*/
@media (max-width:1024px) {
    .hero-single .hero_headings {
        width: 100%;
        top: 50%;
    }
}

/*!sc*/
.hero-single .hero_headings h2 {
    font-size: 1.7em;
    color: white;
    font-weight: 400;
    margin-bottom: 30px;
    -webkit-letter-spacing: 1.5px;
    -moz-letter-spacing: 1.5px;
    -ms-letter-spacing: 1.5px;
    letter-spacing: 1.5px;
}

/*!sc*/
@media (max-width:1024px) {
    .hero-single .hero_headings h2 {
        margin-bottom: 5px;
        font-size: 1.3em;
    }
}

/*!sc*/
.hero-single .hero_headings h3 {
    -webkit-text-decoration: none;
    text-decoration: none;
    color: #d8d8d8;
    -webkit-letter-spacing: 1.5px;
    -moz-letter-spacing: 1.5px;
    -ms-letter-spacing: 1.5px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    font-size: 0.6em;
    padding: 12px 18px;
    font-weight: 300;
}

/*!sc*/
.hero-single .hero_headings .hero-input {
    height: 40px;
    width: 100%;
    font-size: 15px;
}

/*!sc*/
@media (max-width:1024px) {
    .hero-single .hero_headings .hero-input {
        height: 35px;
        font-size: 14px;
        margin-top: 16px;
    }
}

/*!sc*/
.hero-single .hero_headings .hero-input input {
    width: 100%;
    height: 100%;
    display: block;
    background-color: white;
    border: 0;
    outline: 0;
    padding: 16px;
    margin: 0 auto;
}

/*!sc*/
@media (max-width:1024px) {
    .hero-single .hero_headings .hero-input input {
        width: 45%;
    }
}

/*!sc*/
@media (max-width:768px) {
    .hero-single .hero_headings .hero-input input {
        width: 90%;
    }
}

/*!sc*/
@media (max-width:480px) {
    .hero-single .hero_headings .hero-input input {
        width: 90%;
    }
}


/*!sc*/
.hardware-parts {
    overflow: hidden;
}

/*!sc*/
.hardware-parts.section_paddings {
    padding-bottom: 110px;
}

/*!sc*/
@media (max-width:1024px) {
    .hardware-parts.section_paddings {
        padding-bottom: 60px;
    }
}

/*!sc*/
.hardware-parts .container {
    max-width: 1300px;
}

/*!sc*/
.hardware-parts .container .react-tabs__tab-list {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    margin-bottom: 80px;
}

/*!sc*/
@media (max-width:768px) {
    .hardware-parts .container .react-tabs__tab-list {
        grid-template-columns: repeat(3, 1fr);
        margin-bottom: 30px;
    }
}

/*!sc*/
@media (max-width:480px) {
    .hardware-parts .container .react-tabs__tab-list {
        grid-template-columns: 1fr 1fr;
        border-bottom: none;
        gap: 10px;
    }
}

/*!sc*/
.hardware-parts .container .react-tabs__tab-list .react-tabs__tab {
    border-radius: 0;
    text-align: center;
    padding: 16px 10px;
    font-size: 0.6em;
    color: var(--brand_black);
    -webkit-letter-spacing: 1.5px;
    -moz-letter-spacing: 1.5px;
    -ms-letter-spacing: 1.5px;
    letter-spacing: 1.5px;
}

/*!sc*/
@media (max-width:1024px) {
    .hardware-parts .container .react-tabs__tab-list .react-tabs__tab {
        border: 1px solid #efefef;
    }
}

/*!sc*/
.hardware-parts .container .react-tabs__tab-list .react-tabs__tab--selected {
    background-color: #f7f5f4;
    border-color: #e0e0e0;
}

/*!sc*/
@media (max-width:480px) {
    .hardware-parts .container .react-tabs__tab-list .react-tabs__tab--selected {
        border-bottom: 1px solid transparent;
        border-color: #dee2e6;
    }
}

/*!sc*/
.hardware-parts .container .list_items {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 40px 30px;
}

/*!sc*/
@media (max-width:1024px) {
    .hardware-parts .container .list_items {
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
    }
}

/*!sc*/
.hardware-parts .container .list_items li {
    list-style-type: none;
}

/*!sc*/
.hardware-parts .container .list_items li:hover a img {
    -webkit-transform: translate(-50%, -50%) scale(1.1);
    -ms-transform: translate(-50%, -50%) scale(1.1);
    transform: translate(-50%, -50%) scale(1.1);
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.hardware-parts .container .list_items li a {
    -webkit-text-decoration: none;
    text-decoration: none;
    display: block;
}

/*!sc*/
.hardware-parts .container .list_items li a .image_wrapper {
    padding-top: 100%;
    position: relative;
    overflow: hidden;
    display: block;
    border-radius: 6px;
    border: 1px solid var(--border_grey);
    overflow: hidden;
    width: 100%;
    margin-bottom: 10px;
    background-color: white;
}

/*!sc*/
.hardware-parts .container .list_items li a .image_wrapper img {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    min-height: 100%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    object-fit: cover;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
@media (max-width:480px) {
    .hardware-parts .container .list_items li a .image_wrapper img {
        max-width: 70%;
        min-height: auto;
    }
}

/*!sc*/
.hardware-parts .container .list_items li a h3 {
    font-size: 0.6em;
    font-weight: 400;
    color: var(--brand_black);
    -webkit-letter-spacing: 1px;
    -moz-letter-spacing: 1px;
    -ms-letter-spacing: 1px;
    letter-spacing: 1px;
    -webkit-text-decoration: none;
    text-decoration: none;
}


/*!sc*/
.window-key-elements {
    overflow: hidden;
    padding-bottom: 80px;
}

/*!sc*/
@media (max-width:1024px) {
    .window-key-elements {
        padding-bottom: 80px;
    }
}

/*!sc*/
.window-key-elements .container {
    overflow: hidden;
    max-width: 1100px;
}

/*!sc*/
.window-key-elements .container .element {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 30px;
}

/*!sc*/
@media (max-width:768px) {
    .window-key-elements .container .element {
        grid-template-columns: 1fr;
        gap: 15px;
        margin-bottom: 0px;
    }
}

/*!sc*/
.window-key-elements .container .element:last-of-type {
    margin-bottom: 0;
}

/*!sc*/
@media (max-width:1024px) {
    .window-key-elements .container .element:last-of-type .content_wrap .section_description {
        margin-bottom: 0;
    }
}

/*!sc*/
.window-key-elements .container .element .image {
    position: relative;
    padding-top: 100%;
    overflow: hidden;
}

/*!sc*/
@media (max-width:1024px) {
    .window-key-elements .container .element .image {
        padding-top: 75%;
    }
}

/*!sc*/
.window-key-elements .container .element .image img {
    display: block;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    object-fit: cover;
}

/*!sc*/
@media (max-width:480px) {
    .window-key-elements .container .element .content_wrap {
        text-align: center;
    }
}

/*!sc*/
.window-key-elements .container .element .content_wrap h3 {
    text-align: left;
    margin-bottom: 30px;
}

/*!sc*/
@media (max-width:1024px) {
    .window-key-elements .container .element .content_wrap h3 {
        margin-bottom: 15px;
    }
}

/*!sc*/
.window-key-elements .container .element .content_wrap .content {
    text-align: left;
    color: #424242;
    font-weight: 300;
    max-width: 440px;
}

/*!sc*/
data-styled.g25[id=""] {
    content: "window-key-elements,"
}

/*!sc*/
.product-intro {
    padding: 80px 0;
    padding-bottom: 80px;
    -webkit-transition: var(--transition);
    transition: var(--transition);
    overflow: hidden;
}

/*!sc*/
@media (max-width:768px) {
    .product-intro {
        padding-bottom: 15px;
        padding-top: 15px;
    }
}

/*!sc*/
.product-intro .container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

/*!sc*/
@media (max-width:768px) {
    .product-intro .container {
        grid-template-columns: 1fr;
    }
}

/*!sc*/
.product-intro .container .product_featured {
    display: block;
    position: relative;
    overflow: hidden;
}

/*!sc*/
@media (max-width:1024px) {
    .product-intro .container .product_featured [data-rmiz-wrap] {
        padding-top: 75%;
    }
}

/*!sc*/
.product-intro .container .product_featured img {
    display: block;
    width: 100%;
    object-fit: cover;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
@media (max-width:1024px) {
    .product-intro .container .product_featured img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }
}

/*!sc*/
data-styled.g27[id="slug__ProductIntro-sc-1woj9v6-0"] {
    content: "product-intro,"
}

/*!sc*/
.product-specification {
    -webkit-transition: var(--transition);
    transition: var(--transition);
    overflow: hidden;
    padding-bottom: 80px;
}

/*!sc*/
@media (max-width:1024px) {
    .product-specification {
        padding-top: 40px;
    }
}

/*!sc*/
.product-specification .content {
    text-align: center;
    margin-bottom: 60px;
}

/*!sc*/
@media (max-width:1024px) {
    .product-specification .content {
        margin-bottom: 40px;
    }
}

/*!sc*/
.product-specification .content h4 {
    font-size: 1.4em;
    font-weight: 500;
    margin-bottom: 60px;
}

/*!sc*/
.product-specification .content img {
    display: inline-block;
    max-width: 100%;
    height: auto;
}

/*!sc*/
.product-specification .link_wrapper {
    margin-top: 0;
}

/*!sc*/
data-styled.g28[id=""] {
    content: "product-specification,"
}

/*!sc*/
.window-product-types {
    margin-bottom: 50px;
    -webkit-transition: var(--transition);
    transition: var(--transition);

    li {
        margin-bottom: 10px;
    }
}

/*!sc*/
@media (max-width:1024px) {
    .window-product-types {
        margin-bottom: 40px;
    }
}

/*!sc*/
.window-product-types.fade_in {
    opacity: 1;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.window-product-types li {
    list-style-type: none;
    display: inline-block;
}

/*!sc*/
.window-product-types li.is_active a {
    background-color: var(--brand_black);
    color: white;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
}

/*!sc*/
.window-product-types li a {
    display: block;
    -webkit-text-decoration: none;
    text-decoration: none;
    color: var(--brand_black);
    border: 1px solid var(--border_grey);
    font-size: 0.6em;
    padding: 13px 15px;
    margin: 0 8px;
    min-width: 130px;
    -webkit-letter-spacing: 1.1px;
    -moz-letter-spacing: 1.1px;
    -ms-letter-spacing: 1.1px;
    letter-spacing: 1.1px;
    text-transform: uppercase;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
}

/*!sc*/
.window-product-types li a:hover {
    background-color: var(--brand_black);
    color: white;
    border: 1px solid var(--brand_black);
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
}

.solutions-section {
    margin-top: 140px;
    padding-bottom: 100px;
}

/*!sc*/
@media (max-width:1024px) {
    .solutions-section {
        margin-top: 80px;
    }
}

/*!sc*/
.solutions-section .back_to_projects {
    position: absolute;
    cursor: pointer;
    color: var(--brand_black);
    -webkit-text-decoration: none;
    text-decoration: none;
    font-size: 13px;
    line-height: 1;
    border: 1px solid var(--brand_black);
    padding: 12px 40px;
    padding-right: 20px;
    border-radius: 3px;
    position: absolute;
    top: 300px;
    left: 70px;
    -webkit-transition: var(--transition);
    transition: var(--transition);
    z-index: 3;
}

/*!sc*/
@media (max-width:1024px) {
    .solutions-section .back_to_projects {
        left: 15px;
        top: 70px;
    }
}

/*!sc*/
.solutions-section .back_to_projects:hover {
    background-color: var(--brand_black);
    color: white;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.solutions-section .back_to_projects:hover svg {
    fill: white;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.solutions-section .back_to_projects svg {
    position: absolute;
    height: 17px;
    left: 10px;
    top: 10px;
    fill: var(--brand_black);
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.solutions-section .container {
    margin: 0 auto;
    width: 100%;
}

/*!sc*/
.solutions-section .container .solutions_wrapper {
    margin-top: 118px;
}

/*!sc*/
.solutions-section .container .solutions_wrapper:first-child {
    margin-top: 0;
}

/*!sc*/
.solutions-section .container .solutions_wrapper .solutions_heading {
    padding: 80px 0;
}

/*!sc*/
@media (max-width:480px) {
    .solutions-section .container .solutions_wrapper .solutions_heading {
        text-align: center;
        padding: 60px;
        padding-bottom: 20px;
    }
}

/*!sc*/
.solutions-section .container .solutions_wrapper .solutions_heading h2 {
    font-weight: 300;
}

/*!sc*/
.solutions-section .container .solutions_wrapper .solutions_images_grid h3 {
    text-align: left;
    font-size: 1em;
}

/*!sc*/
.solutions-section .container .solutions_wrapper .solutions_images_grid .image_container {
    display: grid;
    position: relative;
    overflow: hidden;
    grid-template-columns: repeat(2, 1fr);
    -webkit-column-gap: 30px;
    column-gap: 30px;
    row-gap: 70px;
}

/*!sc*/
@media (max-width:480px) {
    .solutions-section .container .solutions_wrapper .solutions_images_grid .image_container {
        grid-template-columns: 1fr;
    }
}

/*!sc*/
.solutions-section .container .solutions_wrapper .solutions_images_grid .image_container img {
    display: block;
    width: 100%;
    max-height: 1200px !important;
    margin-bottom: 60px;
}

/*!sc*/
.solutions-section .container .solutions_wrapper .solutions_images_grid .image_container .__react_modal_image__modal_container img {
    width: auto;
}


.about-product {
    padding-bottom: 80px;
}

/*!sc*/
@media (max-width:1024px) {
    .about-product {
        padding-bottom: 60px;
    }
}

/*!sc*/
.about-product .container {
    text-align: center;
}

/*!sc*/
.about-product .container h4 {
    font-weight: 300;
    font-size: 1em;
    margin-bottom: 30px;
}

/*!sc*/
@media (max-width:1024px) {}

/*!sc*/
.about-product .container h2,
.about-product .container .content_title {
    margin-bottom: 40px;
}

/*!sc*/
.about-product .container h2.suitable_title,
.about-product .container .content_title.suitable_title {
    margin-bottom: 20px;
    font-size: 1em;
}

/*!sc*/
@media (max-width:1024px) {

    .about-product .container h2,
    .about-product .container .content_title {
        margin-bottom: 40px;
    }
}

/*!sc*/
.about-product .container .content {
    color: var(--text_grey);
    font-size: 0.8em;
    font-weight: 300;
    margin-bottom: 60px;
}

/*!sc*/
@media (max-width:768px) {
    .about-product .container .content {
        margin-bottom: 40px;
    }
}

/*!sc*/
.about-product .container .suitable_list {
    text-align: center;
}

/*!sc*/
.about-product .container .suitable_list ul li {
    list-style-type: none;
    display: inline-block;
    padding: 0 15px;
    -webkit-text-decoration: none;
    text-decoration: none;
    font-size: 0.8em;
    -webkit-letter-spacing: 1.1px;
    -moz-letter-spacing: 1.1px;
    -ms-letter-spacing: 1.1px;
    letter-spacing: 1.1px;
    font-weight: 400;
    color: var(--text_grey);
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
@media (max-width:1024px) {
    .about-product .container .suitable_list ul li {
        display: block;
    }
}

/*!sc*/
.about-product .container .suitable_list ul li a {
    -webkit-text-decoration: none;
    text-decoration: none;
    -webkit-letter-spacing: 1.1px;
    -moz-letter-spacing: 1.1px;
    -ms-letter-spacing: 1.1px;
    letter-spacing: 1.1px;
    font-weight: 400;
    color: var(--text_grey);
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.about-product .container .suitable_list ul li a:hover {
    color: var(--brand_black);
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
data-styled.g9[id="handle-series__AboutProduct-zwt69-1"] {
    content: "about-product,"
}

.product-image-content {
    margin-bottom: 200px;
}

/*!sc*/
@media (max-width:768px) {
    .product-image-content {
        margin-bottom: 0px;
    }
}

/*!sc*/
.product-image-content .container_image_content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    max-width: 1390px;
    margin: 0 auto;
    margin-bottom: 30px;
}

/*!sc*/
@media (max-width:1640px) {
    .product-image-content .container_image_content {
        max-width: 1070px;
    }
}

/*!sc*/
@media (max-width:768px) {
    .product-image-content .container_image_content {
        grid-template-columns: 1fr;
        max-width: 100%;
        padding: 0 15px;
    }
}

/*!sc*/
.product-image-content .container_image_content:nth-child(even) .content_container {
    grid-row-start: 1;
    grid-column: 1;
}

/*!sc*/
@media (max-width:768px) {
    .product-image-content .container_image_content:nth-child(even) .content_container {
        grid-row-start: auto;
        grid-column: auto;
    }
}

/*!sc*/
.product-image-content .container_image_content:nth-child(even) .img_container {
    grid-row-start: 1;
    grid-column: 2;
}

/*!sc*/
@media (max-width:768px) {
    .product-image-content .container_image_content:nth-child(even) .img_container {
        grid-row-start: auto;
        grid-column: auto;
    }
}

/*!sc*/
.product-image-content .container_image_content .img_container {
    position: relative;
    height: 515px;
    overflow: hidden;
}

/*!sc*/
.product-image-content .container_image_content .img_container img {
    display: block;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    object-fit: cover;
}

/*!sc*/
.product-image-content .container_image_content .content_container {
    position: relative;
    padding: 0 100px;
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    align-self: center;
    text-align: center;
}

/*!sc*/
@media (max-width:768px) {
    .product-image-content .container_image_content .content_container {
        padding: 0;
    }
}

/*!sc*/
.product-image-content .container_image_content .content_container .title {
    text-align: center;
    font-size: 1.4em;
    font-weight: 500;
    margin-bottom: 30px;
    color: var(--text_grey_dark);
}

/*!sc*/
.product-image-content .container_image_content .content_container .description {
    text-align: center;
    color: var(--text_grey);
    font-size: 0.7em;
    font-weight: 300;
    max-width: 500px;
    margin: 0 auto;
    margin-bottom: 30px;
}

.bolkKp {
    padding: 80px 0px;
    overflow: hidden;
}

/*!sc*/
/*!sc*/
</style>